import React from "react";
import { FeatureRequest } from "interfaces/feature-request";
import styled from "styled-components";
import styles from "../../styles/styles";
import DetailsTimeline from "./components/DetailsTimeline";
import FeatureRequestSolutionDescription from "./FeatureRequestSolutionDescription";
import isEmpty from "lodash/isEmpty";

const HeaderContainer = styled.div`
    padding-top: 3rem;
`;

const DetailsHeader = styled.h4`
    padding-top: 1.5rem;
    font-weight: 400;
    font-size: 32px;
`;

const ContentHeader = styled.h5`
    font-weight: 400;
    font-size: 24px;
    margin-bottom: 0;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    padding: 0;
    color: ${styles.colors.red};
    display: flex;
    align-items: center;
    gap: ${styles.spacing[1]};

    &:before {
        content: "←";
        font-size: 20px;
    }

    &:hover {
        color: ${styles.colors.darkRed};
    }
`;

const ContentContainer = styled.div``;

const Paragraph = styled.p`
    margin-top: 0.5rem;
    font-size: 16px;
    font-weight: 400;
`;

interface FeatureRequestDetailsProps {
    featureRequest: FeatureRequest;
    onBack: () => void;
}

const FeatureRequestDetails: React.FC<FeatureRequestDetailsProps> = ({
    featureRequest,
    onBack,
}) => (
    <>
        <HeaderContainer>
            <CloseButton onClick={onBack} aria-label="Sulje ikkuna">
                Takaisin
            </CloseButton>
            <DetailsHeader>{featureRequest.name}</DetailsHeader>
        </HeaderContainer>
        <DetailsTimeline featureRequest={featureRequest} />
        <ContentContainer>
            <ContentHeader>Kuvaus</ContentHeader>
            <Paragraph>{featureRequest.description}</Paragraph>
        </ContentContainer>
        <ContentContainer>
            <ContentHeader>Ratkaisukuvaus</ContentHeader>
            {isEmpty(featureRequest.solutionDescription) ? (
                <Paragraph>-</Paragraph>
            ) : (
                <FeatureRequestSolutionDescription
                    solutionDescription={featureRequest.solutionDescription}
                />
            )}
        </ContentContainer>
        <ContentContainer>
            <ContentHeader>Ehdotuksen perustelu</ContentHeader>
            <Paragraph>-</Paragraph>
        </ContentContainer>
    </>
);

export default FeatureRequestDetails;
